<template>
  <second-nav />
  <hero-carousel /><key-features /><platform-benefits /><experience-years /><ready-page /><ask-as /><footer-page />
</template>

<script>
import SecondNav from "@/components/layout/AppNavigation.vue";
import HeroCarousel from "@/components/features/HeroCarousel/HeroCarousel.vue";
import KeyFeatures from "@/components/features/KeyFeatures/KeyFeatures.vue";
import PlatformBenefits from "@/components/features/PlatformBenefits/PlatformBenefits.vue";
import FooterPage from "@/components/layout/AppFooter.vue";
import AskAs from "@/components/features/AskAs/AskAs.vue";
import ExperienceYears from "@/components/features/ExperienceYears/ExperienceYears.vue";
import ReadyPage from "@/components/features/ReadytoJoin/ReadyPage.vue";
export default {
  name: "HomeView",
  components: {
    HeroCarousel,
    SecondNav,
    PlatformBenefits,
    KeyFeatures,
    FooterPage,
    AskAs,
    ExperienceYears,
    ReadyPage,
  },
  data() {
    return {
      mobileMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    navigateTo() {
      // You could use this.$router.push() for navigation
      // if you're using Vue Router
    },
  },
};
</script>

<style scoped>
.banner-bg {
  background-image: url("https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1920&h=800&q=80");
  background-size: cover;
  background-position: center;
  min-height: 700px;
  position: relative;
}

/* Hexagon container */
.hexagon-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Hexagon item positioning - clustered tightly on the left side */
.hexagon-item {
  position: absolute;
  transform: translate(-50%, -50%);
}

/* Specific positioning for each hexagon - reduced spacing */
.vsls-position {
  top: 25%;
  left: 25%;
}

.market-position {
  top: 41%;
  left: 13%;
}

.pmis-position {
  top: 41%;
  left: 37%;
}

.pension-position {
  top: 50%;
  left: 25%;
}

.weather-position {
  top: 66%;
  left: 13%;
}

.transport-position {
  top: 66%;
  left: 37%;
}

.community-position {
  top: 75%;
  left: 25%;
}

/* Hexagon styling with curved edges */
.hexagon {
  width: 140px;
  height: 140px;
  position: relative;
  background-color: white;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  cursor: pointer;
  border-width: 3px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  /* Hexagon shape with curved edges */
  -webkit-clip-path: polygon(
    50% 0%,
    95% 25%,
    95% 75%,
    50% 100%,
    5% 75%,
    5% 25%
  );
  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
}

.hexagon:hover {
  transform: scale(1.05);
}

.hexagon-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  text-align: center;
}

.hexagon-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}

.hexagon-label {
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .hexagon {
    width: 120px;
    height: 120px;
  }

  .hexagon-icon {
    width: 40px;
    height: 40px;
  }

  .hexagon-label {
    font-size: 14px;
  }

  /* Center positioning for medium screens */
  .vsls-position {
    top: 25%;
    left: 50%;
  }

  .market-position {
    top: 41%;
    left: 35%;
  }

  .pmis-position {
    top: 41%;
    left: 65%;
  }

  .pension-position {
    top: 50%;
    left: 50%;
  }

  .weather-position {
    top: 66%;
    left: 35%;
  }

  .transport-position {
    top: 66%;
    left: 65%;
  }

  .community-position {
    top: 75%;
    left: 50%;
  }
}

@media (max-width: 640px) {
  .hexagon {
    width: 90px;
    height: 90px;
  }

  .hexagon-icon {
    width: 30px;
    height: 30px;
    margin-bottom: 5px;
  }

  .hexagon-label {
    font-size: 11px;
  }

  /* Centered layout on small screens */
  .vsls-position {
    top: 22%;
    left: 50%;
  }

  .market-position {
    top: 36%;
    left: 35%;
  }

  .pmis-position {
    top: 36%;
    left: 65%;
  }

  .pension-position {
    top: 46%;
    left: 50%;
  }

  .weather-position {
    top: 60%;
    left: 35%;
  }

  .transport-position {
    top: 60%;
    left: 65%;
  }

  .community-position {
    top: 70%;
    left: 50%;
  }
}
</style>
